import './index.scss'
$(document).ready(function() {
  // 每批显示的数量
  var batchSize = 3;
  var currentIndex = 0;
  var items = $('.section2 li');
  
  // 初始状态：只显示第一批
  function initDisplay() {
    if (items.length > batchSize) {
      items.slice(batchSize).hide(); // 隐藏第一批之后的所有项目
      currentIndex = batchSize;
      $('#showMoreBtn').show(); // 显示按钮
    }
  }
  if (items.length < 3) {
      $('#showMoreBtn').hide();
    } 
   
  // 显示更多项目的函数
  function showMore() {
    var nextItems = items.slice(currentIndex, currentIndex + batchSize);
    
    if (nextItems.length > 0) {
      nextItems.fadeIn(300); // 淡入效果显示
      currentIndex += batchSize;
      
      // 如果已经显示完所有项目，隐藏按钮 
      if (currentIndex >= items.length) {
        $('#showMoreBtn').hide();
      }
    }
  }
  
  // 绑定按钮点击事件
  $('#showMoreBtn').click(function() {
    showMore();
  });
  
  // 初始化显示
  initDisplay();
});